import ApiClient from './ApiClient';

export interface ClinicProfile {
  id: number;
  siteId: number;
  address: string;
  phone: string;
  workingHours: string;
  shortDescription: string;
  operatingStatus?: string;
  breakTimeStart?: string;
  breakTimeEnd?: string;
  closedDates?: string;
  appointmentSlots?: string;
  createdAt: string;
}

export interface UpdateClinicHoursDto {
  workingHours?: string;
  breakTimeStart?: string;
  breakTimeEnd?: string;
  operatingStatus?: string;
}

export interface UpdateClinicAvailabilityDto {
  closedDates?: string;
  appointmentSlots?: string;
}

export class ClinicProfileAPI {
  static async getClinicBySiteId(siteId: number): Promise<ClinicProfile> {
    return ApiClient.get(`/api/clinicprofile/site/${siteId}`);
  }

  static async getClinicById(id: number): Promise<ClinicProfile> {
    return ApiClient.get(`/api/clinicprofile/${id}`);
  }

  static async createClinic(clinic: ClinicProfile): Promise<ClinicProfile> {
    return ApiClient.post('/api/clinicprofile', clinic);
  }

  static async updateClinic(id: number, clinic: ClinicProfile): Promise<ClinicProfile> {
    return ApiClient.put(`/api/clinicprofile/${id}`, clinic);
  }

  static async deleteClinic(id: number): Promise<boolean> {
    return ApiClient.delete(`/api/clinicprofile/${id}`);
  }

  static async updateClinicHours(id: number, dto: UpdateClinicHoursDto): Promise<ClinicProfile> {
    return ApiClient.patch(`/api/clinicprofile/${id}/hours`, dto);
  }

  static async updateClinicAvailability(id: number, dto: UpdateClinicAvailabilityDto): Promise<ClinicProfile> {
    return ApiClient.patch(`/api/clinicprofile/${id}/availability`, dto);
  }
}
